import React from "react";
import { Col, Form, InputGroup, Row } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import MaskedInput from "react-text-mask";
import { currencyMask } from "../../utils/utils";
import { emailMask } from "text-mask-addons/dist/textMaskAddons";
import { US_STATES } from '../../utils/constants'; // You'll need to create this constant

interface BasicInfoFieldsProps {
  payee: string;
  amount: number;
  policyNumber?: string;
  isPaymentPlan?: boolean;
  paymentComment?: string;
  handleInputChange: (e: any) => void;
  payorState: string;
}

class BasicInfoFields extends React.Component<BasicInfoFieldsProps> {
  renderInsuredName() {
    return (
      <Row>
        <Col md={{ span: 8, offset: 2 }}>
          <Form.Group style={{ display: "flex", alignItems: "center" }}>
            <FontAwesomeIcon
              icon="building"
              className="fa-lg"
              style={{ marginRight: "12px" }}
            />
            <Form.Control
              placeholder="Insured Name *"
              name="insuredName"
              onChange={this.props.handleInputChange}
            />
          </Form.Group>
        </Col>
      </Row>
    );
  }

  render() {

    return (
      <div>
        <Row>
          <Col>
            <h2 className="text-center">Basic Information</h2>

          </Col>
        </Row>
        <Form.Group>
          <Row>
            <Col md={{ span: 8, offset: 2 }}>
              <Form.Group style={{ display: "flex", alignItems: "center" }}>
                <FontAwesomeIcon
                  icon="user"
                  className="fa-lg"
                  style={{ marginRight: "12px" }}
                />
                <Form.Control
                  placeholder="Payer"
                  name="payerName"
                  onChange={this.props.handleInputChange}
                  value={this.props.payee}
                />
              </Form.Group>
            </Col>
          </Row>
          {!this.props.policyNumber ? this.renderInsuredName() : null}
          <Row>
            <Col md={{ span: 8, offset: 2 }}>
              <Form.Group style={{ display: "flex", alignItems: "center" }}>
                <FontAwesomeIcon
                  icon="envelope"
                  className="fa-lg"
                  style={{ marginRight: "12px" }}
                />
{React.createElement(MaskedInput as any, {
                  mask: emailMask,
                  className: "form-control",
                  placeholder: "Email",
                  guide: false,
                  name: "payerEmail",
                  onChange: this.props.handleInputChange,
                  keepCharPositions: true
                })}
              </Form.Group>
            </Col>
          </Row>
          {!this.props.policyNumber ? (
            <Row>
              <Col md={{ span: 8, offset: 2 }}>
                <Form.Group style={{ display: "flex", alignItems: "center" }}>
                  <FontAwesomeIcon
                    icon="credit-card"
                    className="fa-lg"
                    style={{ marginRight: "12px", maxWidth: "21px" }}
                  />
                  {React.createElement(MaskedInput as any, {
                    mask: currencyMask,
                    className: "form-control",
                    placeholder: "$",
                    guide: false,
                    name: "amount",
                    onChange: this.props.handleInputChange,
                  })}
                </Form.Group>
                <p style={{ display: "flex", justifyContent: "center" }}>
                  *Payment amount
                  <i style={{ paddingRight: "4px", paddingLeft: "4px" }}>
                    before
                  </i>{" "}
                  ePay convenience fee(s)
                </p>
              </Col>
            </Row>
          ) : null}

          {/* <Row>
            <Col md={{ span: 8, offset: 2 }}>
              <Form.Group style={{ display: "flex", alignItems: "center" }}>
                <FontAwesomeIcon
                  icon="tags"
                  className="fa-lg"
                  style={{ marginRight: "12px" }}
                />
                <Form.Control
                  as="select"
                  onChange={this.props.handleInputChange}
                  // value={this.props.isPaymentPlan == false ? "0" : "1"}
                  name="isPaymentPlan"
                >
                  <option disabled>Select payment structure</option>
                  <option value="0">One time payment</option>
                  <option value="1">Installment plan</option>
                </Form.Control>
              </Form.Group>
            </Col>
          </Row> */}

          <Row>
            <Col md={{ span: 8, offset: 2 }}>
              <Form.Group style={{ display: "flex", alignItems: "center" }}>
                <FontAwesomeIcon
                  icon="comment-alt"
                  className="fa-lg"
                  style={{ marginRight: "12px" }}
                />
                <Form.Control
                  as="textarea"
                  onChange={this.props.handleInputChange}
                  value={this.props.paymentComment}
                  // value={this.props.isPaymentPlan == false ? "0" : "1"}
                  name="paymentComment"
                  placeholder="Comments"
                ></Form.Control>
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col md={{ span: 8, offset: 2 }}>
              <Form.Group style={{ display: "flex", alignItems: "center" }}>
                <FontAwesomeIcon
                  icon="map-marker-alt"
                  className="fa-lg"
                  style={{ marginRight: "12px" }}
                />
                <Form.Control
                  as="select"
                  name="payorState"
                  onChange={this.props.handleInputChange}
                  value={this.props.payorState}
                >
                  <option value="">Select Payor Location</option>
                  {US_STATES.map(state => (
                    <option key={state.abbreviation} value={state.id}>
                      {state.name}
                    </option>
                  ))}
                </Form.Control>
              </Form.Group>
            </Col>
          </Row>

        </Form.Group>
      </div>
    );
  }
}

export default BasicInfoFields;
